import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";

// Import MazUi
import { MazUi } from "maz-ui/dist/plugins/maz-ui";
import "maz-ui/dist/css/main.css";

// Import Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Import Font Awesome
import "@fortawesome/fontawesome-free/css/all.min.css";

// Import custom styles
import "./assets/scss/argon-dashboard.scss";
import "./assets/scss/global-mobile-fixes.scss";
import "./assets/scss/desktop-responsive.scss";

// Import DataTables CSS
import "datatables.net-bs5/css/dataTables.bootstrap5.css";

// Create Vue app instance
const app = createApp(App);

// Use plugins
app.use(store);
app.use(router);
app.use(MazUi, {
  theme: {},
  translations: {
    locale: "es",
  },
  // Ensure all components are registered
  components: true,
});

// Initialize authentication state with a small delay to ensure store is ready
setTimeout(() => {
  // Check if there's a token in URL parameters first
  const urlParams = new URLSearchParams(window.location.search);
  const tokenInUrl = urlParams.get("token");
  const existingToken = localStorage.getItem("authToken");

  if (tokenInUrl) {
    if (existingToken) {
      // Clear old authentication state
      store.dispatch("logout");
    }

    // Store the new URL token in localStorage to override any existing token
    localStorage.setItem("authToken", tokenInUrl);
  }

  store.dispatch("initializeAuth");
}, 100);

// Mount the app
app.mount("#app");
